import React from 'react';
import type { FC } from 'react';
import styles from './DotsLoader.module.scss';

const DotsLoader: FC = () => (
  <span className={styles.dots} aria-hidden="true">
    {[0, 1, 2].map(i => (
      <span key={i} />
    ))}
  </span>
);

export default DotsLoader;
